import { apiSlice } from "./apiSlice";
import domain from "../util/domain";
const PLAYLISTS_URL = `${domain}/api/playlists`;

export const playlistsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDaysPlaylist: builder.query({
      query: (playlistDate) => ({
        url: `${PLAYLISTS_URL}/daysplaylist/${playlistDate}`,
      }),
      providesTags: ["PlaylistPrograms"],
    }),
    getScheduleDays: builder.query({
      query: () => ({
        url: `${PLAYLISTS_URL}/scheduledays`,
      }),
      providesTags: ["PlaylistPrograms"],
    }),
    getSchedulePrograms: builder.query({
      query: (dateId) => ({
        url: `${PLAYLISTS_URL}/scheduleprograms/${dateId}`,
      }),
      providesTags: ["PlaylistPrograms"],
    }),
    getEPGData: builder.query({
      query: (days) => ({
        url: `${PLAYLISTS_URL}/getepgdata/${days}`,
      }),
      providesTags: ["EPGData"],
    }),
    deletePlaylistProgram: builder.mutation({
      query: (id) => ({
        url: `${PLAYLISTS_URL}/deleteplaylistprogram/${id}`,
        method: "DELETE",
        body: id,
      }),
      invalidatesTags: ["PlaylistPrograms"],
    }),
    insertPlaylistProgram: builder.mutation({
      query: (programData) => ({
        url: `${PLAYLISTS_URL}/insertplaylistprogram`,
        method: "POST",
        body: programData,
      }),
      invalidatesTags: ["PlaylistPrograms"],
    }),
    updatePlaylistProgram: builder.mutation({
      query: (programData) => ({
        url: `${PLAYLISTS_URL}/updateplaylistprogram/${programData._id}`,
        method: "PUT",
        body: programData,
      }),
      invalidatesTags: ["PlaylistPrograms", "EPGData"],
    }),
    updatePlaylistFromTemplate: builder.mutation({
      query: (days) => ({
        url: `${PLAYLISTS_URL}/playlistupdateprocess/${days}`,
        method: "POST",
      }),
      invalidatesTags: ["PlaylistPrograms"],
    }),
    updateEpg: builder.mutation({
      query: (epgVersions) => ({
        url: `${PLAYLISTS_URL}/updateepg`,
        method: "POST",
        body: epgVersions,
      }),
      invalidatesTags: ["PlaylistPrograms"],
    }),
    populatePrograms: builder.mutation({
      query: (allPrograms) => ({
        url: `${PLAYLISTS_URL}/populateprograms`,
        method: "POST",
        body: allPrograms,
      }),
      invalidatesTags: ["PlaylistPrograms"],
    }),
    rePopulatePrograms: builder.mutation({
      query: (allPrograms) => ({
        url: `${PLAYLISTS_URL}/repopulateprograms`,
        method: "POST",
        body: allPrograms,
      }),
      invalidatesTags: ["PlaylistPrograms"],
    }),
    saveSongAddPromoPlays: builder.mutation({
      query: (allPrograms) => ({
        url: `${PLAYLISTS_URL}/savesongaddpromoplays`,
        method: "POST",
        body: allPrograms,
      }),
      invalidatesTags: ["PlaylistPrograms"],
    }),
    lockDate: builder.mutation({
      query: (lockDateData) => ({
        url: `${PLAYLISTS_URL}/lockdate`,
        method: "POST",
        body: lockDateData,
      }),
      invalidatesTags: ["PlaylistPrograms"],
    }),
  }),
});

export const {
  useDeletePlaylistProgramMutation,
  useInsertPlaylistProgramMutation,
  useUpdatePlaylistProgramMutation,
  useUpdatePlaylistFromTemplateMutation,
  useGetScheduleDaysQuery,
  useGetScheduleProgramsQuery,
  useGetDaysPlaylistQuery,
  useGetEPGDataQuery,
  useUpdateEpgMutation,
  usePopulateProgramsMutation,
  useRePopulateProgramsMutation,
  useSaveSongAddPromoPlaysMutation,
  useLockDateMutation,
} = playlistsApiSlice;
